import './SubmitActionPopup.css';
import React from "react";
import MiniPreloader from '../MiniPreloader/MiniPreloader';







function SubmitActionPopup({ isOpen, hendleClose, hendleSubmit, text, submitText, cencelText, isSubmitPreloader }) {

  return (
    <div className={`submit-act-popup ${isOpen ? 'submit-act-popup_active' : ''}`}>
      <div className={`submit-act-popup__container ${isOpen ? 'submit-act-popup__container_active' : ''}`}>
        <div className="submit-act-popup__close" onClick={hendleClose}>
          <svg className="submit-act-popup__close-icon" width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M2 18L18 2M2 2L18 18" stroke="black" strokeWidth="3.2" strokeLinecap="round" />
          </svg>
        </div>
        <p className="submit-act-popup__text">{text}</p>
        <div className="submit-act-popup__btns">
          <div className="submit-act-popup__btn submit-act-popup__btn_agree" onClick={hendleSubmit}>
            {isSubmitPreloader ?
              <MiniPreloader isLinkColor={true} />
              :
              <p className="submit-act-popup__btn-text submit-act-popup__btn-text_agree">{submitText}</p>
            }
          </div>
          <div className="submit-act-popup__btn submit-act-popup__btn_disagree" onClick={hendleClose}>
            <p className="submit-act-popup__btn-text submit-act-popup__btn-text_disagree">{cencelText}</p>
          </div>
        </div>

      </div>
      <div className={`submit-act-popup__background ${isOpen ? 'submit-act-popup__background_active' : ''}`} onClick={hendleClose}>

      </div>
    </div>
  );
}

export default SubmitActionPopup;
